import { Stack } from '@mui/material';
import FrameCard from 'Global/Components/CommonComponents/FrameCard/FrameCard';
import React, { forwardRef, useState } from 'react';
import PatientInfoSummurary from '../PatientInfoSummurary';
import PatientActionBoxTrigger from '../PatientActionBoxTrigger';
import PatienCardActions from '../PatienCardActions';

const PatientCard = forwardRef(({ Patient }, ref) => {
  const [files, setFiles] = useState(
    () =>
      sessionStorage.getItem('files') &&
      JSON.parse(sessionStorage.getItem('files'))
  );
  const lastFile = files ? files[files?.length - 1] : null;

  return (
    <React.Fragment>
      <FrameCard
        cardProps={{
          padding: '3px',
          borderRadius: '15px',
          // maxWidth: 'fit-content',
          alignSelf: 'center',
          width: '100% !important',
          backgroundColor: 'black',
        }}
        jsx={
          <Stack
            sx={{
              userSelect: 'none',
              backgroundColor: 'white',
              borderRadius: '20px',
              padding: '.3em',
            }}
            gap="1em"
          >
            <PatientInfoSummurary Patient={Patient} />
            <PatientActionBoxTrigger
              Patient={Patient}
              setFiles={setFiles}
              files={files}
            />
            <div
              ref={lastFile === Patient.FldId ? ref : null}
            ></div>
            {files?.includes(Patient?.FldId) ? (
              <div
                style={{ padding: '1em', paddingInline: 0 }}
              >
                <hr />
                <PatienCardActions Patient={Patient} />
              </div>
            ) : (
              <></>
            )}
          </Stack>
        }
      />
    </React.Fragment>
  );
});

export default PatientCard;
